import {useEffect, useState} from "react";
import {Card, Menu} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import {ProfileSection} from "@/pages/resume/components/sections/ProfileSection";
import {CreateCV} from "@/pages/resume/components/sections/CreateCV";
import {CVLists} from "@/pages/resume/components/sections/CVLists";
import FadeInWhenVisible from "@/components/animations/FadeInWhenVisible";
import LoginPopup from "@/components/ui/LoginPopup";
import {MenuOutlined} from "@ant-design/icons";

export const ResumeIndex = () => {
    const [key, setKey] = useState("profile");
    const [cvList, setCvList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [tab, setTab] = useState("1");

    const handleClick = e => setKey(e.key);
    const handleSaveCV = (cvData) => {
        setCvList([...cvList, cvData]);
    }

    const contentMap = {
        profile: {
            content: <ProfileSection/>

        },
        createCV: {
            content: <CreateCV onSave={handleSaveCV}/>

        },
        manageCV: {
            content: <CVLists cvList={cvList}/>

        }
    };

    useEffect(() => {
        setIsModalVisible(true);
    }, []);
    return (
        <FadeInWhenVisible>
            <div className="p-6 lg:p-12 hidden bg-white lg:flex gap-6">
                <Card className="w-1/4 shadow-lg sticky top-24 max-h-fit">
                    <Menu onClick={handleClick} mode="vertical" selectedKeys={[key]}>
                        <Menu.Item key="profile" icon={<FontAwesomeIcon icon={faArrowRight}/>}>Thông tin cá
                            nhân</Menu.Item>
                        <Menu.Item key="createCV" icon={<FontAwesomeIcon icon={faArrowRight}/>}>Tạo/cập nhật
                            CV</Menu.Item>
                        <Menu.Item key="manageCV" icon={<FontAwesomeIcon icon={faArrowRight}/>}>Quản lý CV</Menu.Item>
                    </Menu>
                </Card>
                <Card className="w-3/4 shadow-lg">
                    {contentMap[key].content}
                </Card>
            </div>
            {/*MOBILE*/}
            <div className={"lg:hidden w-full p-6 gap-6"}>
                <Menu mode="horizontal" selectedKeys={[tab]}
                      onClick={(e) => setTab(e.key)}
                      className="bg-white shadow-md rounded-lg mb-4">
                    <Menu.Item key="1" icon={<MenuOutlined/>}>
                        Thông tin cá nhân
                    </Menu.Item>
                    <Menu.Item key="2" icon={<MenuOutlined/>}>
                        Tạo/Cập nhật CV
                    </Menu.Item>
                    <Menu.Item key="3" icon={<MenuOutlined/>}>
                        Quản lý CV
                    </Menu.Item>
                </Menu>
                <div className={"bg-white p-4 rounded-lg shadow-md"}>
                    {tab === "1" && (
                        <ProfileSection/>
                    )}
                    {tab === "2" && (
                        <CreateCV onSave={handleSaveCV}/>
                    )}
                    {tab === "3" && (
                        <CVLists cvList={cvList}/>
                    )}
                </div>
            </div>
            <LoginPopup visible={isModalVisible} onClose={() => setIsModalVisible(false)}/>
        </FadeInWhenVisible>
    );
};
